/* Custom Colour Suite builder — paginated experience.
 *
 * COLOUR CODE (line-item property "Colour Code") is SUPPLIER-CRITICAL & locked:
 *   single side: <formula> | N" Root   (drop the pipe part if no root)
 *   Dimension Weft (dual): "Side 1: <s1> // Side 2: <s2>"
 * FORMULA CODE is internal only (attached as a property, never shown to the buyer).
 */
(function () {
  'use strict';
  if (window.__ccsBuilderInit) return;
  window.__ccsBuilderInit = true;

  /* ===================== CONFIG (editable) ===================== */
  var CONFIG = {
    // Parent categories — experience-only grouping. Order shown to the buyer.
    families: [
      { name: 'Tips',  methods: ['Nano', 'Silicone Nano', 'ThreadFlex Nano', 'I-Tip', 'K Tip', 'Mini K Tip'] },
      { name: 'Tapes', methods: ['Tape', 'InvisiFit Tape', 'Tape Weft', 'InvisiFit Tape Weft'] },
      { name: 'Wefts', methods: ['Classic Weft', 'Skinny Weft', 'Double Skinny Weft', 'Dimension Weft', 'Butterfly Weft'] }
    ],
    methodCodes: {
      'Nano': 'NT', 'Silicone Nano': 'SN', 'ThreadFlex Nano': 'TN',
      'I-Tip': 'IT', 'K Tip': 'KT', 'Mini K Tip': 'MK',
      'Classic Weft': 'WF', 'Skinny Weft': 'SW', 'Double Skinny Weft': 'SV', 'Dimension Weft': 'DW', 'Butterfly Weft': 'BF',
      'Tape': 'TP', 'InvisiFit Tape': 'IF', 'Tape Weft': 'TW', 'InvisiFit Tape Weft': 'IW'
    },
    // Unambiguous names for the order/process sheet. Option values stay as-is
    // (the builder matches them exactly); only the recorded properties use these.
    methodLabels: { 'Nano': 'Metal Nano' },
    rootLengths: ['None', '2"', '3"'],
    // Lengths to hide for now (matched by number). Empty the array to show them again.
    hiddenLengths: ['26', '28'],
    // No "Rooted" — a root is implied by choosing a root length.
    // cc = Colour Code letter (SUPPLIER); single uses "/" and exactly one colour.
    blends: [
      { name: 'Single colour', cc: '', code: 'SC', single: true,  min: 1, max: 1 },
      { name: 'Piano',         cc: 'P', code: 'PN', single: false, min: 2, max: 3 },
      { name: 'Mixed',         cc: 'M', code: 'MX', single: false, min: 2, max: 3 }
    ],
    dualSideMethods: ['Dimension Weft']
  };

  /* ===================== helpers ===================== */
  function unique(a) { return a.filter(function (v, i) { return a.indexOf(v) === i; }); }
  function strip(s) { return (s || '').replace(/^#/, '').replace(/^0/, ''); }
  function rootNum(l) { return (l || '').replace(/"/g, ''); }
  function lengthNum(l) { var m = (l || '').match(/\d+/); return m ? m[0] : ''; }
  function el(tag, cls, html) { var e = document.createElement(tag); if (cls) e.className = cls; if (html != null) e.innerHTML = html; return e; }
  function blendByName(n) { return CONFIG.blends.filter(function (b) { return b.name === n; })[0]; }
  function isDual(st) { return CONFIG.dualSideMethods.indexOf(st.method) !== -1; }
  function weightGrams(w) { var p = (w || '').match(/\(([^)]*)\)/); var s = p ? p[1] : (w || ''); var m = s.match(/(\d+(?:\.\d+)?)\s*g\b/i); return m ? m[1].replace(/\.0$/, '') : ''; }
  function familyOf(m) { for (var i = 0; i < CONFIG.families.length; i++) if (CONFIG.families[i].methods.indexOf(m) !== -1) return CONFIG.families[i].name; return null; }

  /* ===================== option access ===================== */
  function optionIndex(p) {
    var names = (p.optionNames || []).map(function (n) { return (n || '').toLowerCase(); });
    function f(k, d) { var i = names.findIndex(function (n) { return n.indexOf(k) !== -1; }); return i === -1 ? d : i; }
    return { method: f('method', 0), length: f('length', 1), weight: f('weight', 2) };
  }
  function methodsFor(p) { var oi = optionIndex(p); return unique(p.variants.map(function (v) { return v.options[oi.method]; })); }
  // Lengths sorted numerically (16 → 28), not by Shopify's option order.
  function lengthsFor(p, m) {
    var oi = optionIndex(p);
    return unique(p.variants.filter(function (v) { return v.options[oi.method] === m; }).map(function (v) { return v.options[oi.length]; }))
      .sort(function (a, b) { return (Number(lengthNum(a)) || 0) - (Number(lengthNum(b)) || 0); });
  }
  // Weights sorted ascending by pack/bundle grams; unparseable (e.g. 7-Piece Set) last.
  function weightsFor(p, m, l) {
    var oi = optionIndex(p);
    return unique(p.variants.filter(function (v) { return v.options[oi.method] === m && v.options[oi.length] === l; }).map(function (v) { return v.options[oi.weight]; }))
      .sort(function (a, b) { return (Number(weightGrams(a)) || Infinity) - (Number(weightGrams(b)) || Infinity); });
  }
  function resolveVariant(p, st) { var oi = optionIndex(p); return p.variants.filter(function (v) { return v.options[oi.method] === st.method && v.options[oi.length] === st.length && v.options[oi.weight] === st.weight; })[0] || null; }

  /* ===================== market pricing ===================== */
  // The builder's baked-in prices (ccs_data metafield) are GBP catalogue values,
  // so on any non-GBP market the button must show the session's own contextual
  // price — never a GBP number wearing the local currency symbol. Prices come
  // from the ccs-price-probe section rendered on the product's own URL, where
  // Liquid exposes every variant at the session market's price (the
  // /products/{handle}.js AJAX endpoint silently omits priced variants under
  // Markets, so it can't be used for this).
  var marketPriceMaps = {};
  function marketPricesFor(handle) {
    if (!marketPriceMaps[handle]) {
      marketPriceMaps[handle] = fetch('/products/' + handle + '?section_id=ccs-price-probe', { headers: { 'Accept': 'text/html' } })
        .then(function (r) { return r.ok ? r.text() : null; })
        .then(function (html) {
          var m = html && html.match(/<script[^>]*data-ccs-market-prices[^>]*>([\s\S]*?)<\/script>/);
          return m ? (JSON.parse(m[1]) || null) : null;
        })
        .catch(function () { return null; });
    }
    return marketPriceMaps[handle];
  }
  function formatMoney(cents, currency) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: currency }).format(cents / 100);
    } catch (e) { return null; }
  }

  /* ===================== codes ===================== */
  // Colour tokens, with optional per-colour ratio (custom mode, non-single blend):
  // "8W:20%" when a ratio is set, else "8W".
  function colourTokens(side, b) {
    var custom = b && !b.single && side.ratioMode === 'custom';
    return (side.colours || []).map(function (c) {
      var t = strip(c.label);
      if (custom && side.ratios && side.ratios[c.label] != null) t += ':' + side.ratios[c.label] + '%';
      return t;
    });
  }
  function buildSide(side) {
    var b = blendByName(side.blend);
    if (!b) return '';
    if ((side.colours || []).length < b.min) return '';
    var hasRoot = side.rootLength && side.rootLength !== 'None' && side.rootShade;
    var rootToken = hasRoot ? 'T' + strip(side.rootShade.label) : '';
    var ct = colourTokens(side, b).join('/');
    var formula = b.single ? '#' + rootToken + '/' + ct : '#' + rootToken + b.cc + ct;
    if (hasRoot) formula += ' | ' + rootNum(side.rootLength) + '″ Root';
    return formula;
  }
  function buildColourCode(st) {
    if (isDual(st)) { var s1 = buildSide(st.sides[0]), s2 = buildSide(st.sides[1]); return (s1 && s2) ? ('Side 1: ' + s1 + ' // Side 2: ' + s2) : ''; }
    return buildSide(st.sides[0]);
  }
  // Live/partial code for the preview — builds as soon as colour selections start
  // (root → blend → shades), without waiting for the minimum to be met.
  function buildSidePartial(side) {
    var b = blendByName(side.blend);
    var hasRoot = side.rootLength && side.rootLength !== 'None' && side.rootShade;
    var rootToken = hasRoot ? 'T' + strip(side.rootShade.label) : '';
    var ct = colourTokens(side, b).join('/');
    if (!rootToken && !b && !ct) return '';
    var mid = b ? (b.single ? '/' : b.cc) : '';
    var s = '#' + rootToken + mid + ct;
    if (hasRoot) s += ' | ' + rootNum(side.rootLength) + '″ Root';
    return s;
  }
  function buildColourCodeDisplay(st) {
    if (isDual(st)) { var s1 = buildSidePartial(st.sides[0]), s2 = buildSidePartial(st.sides[1]); if (!s1 && !s2) return ''; return 'Side 1: ' + (s1 || '…') + ' // Side 2: ' + (s2 || '…'); }
    return buildSidePartial(st.sides[0]);
  }
  function sideCodeSeg(side) {
    var seg = [];
    if (side.rootShade) seg.push(strip(side.rootShade.label) + (side.rootLength && side.rootLength !== 'None' ? 'R' + lengthNum(side.rootLength) : 'N'));
    if ((side.colours || []).length) seg.push(side.colours.map(function (c) { return strip(c.label); }).join('-'));
    var b = blendByName(side.blend); if (b) seg.push(b.code);
    return seg.join('-');
  }
  function buildFormulaCode(st) {
    var parts = ['BW'];
    if (st.method) parts.push(CONFIG.methodCodes[st.method] || st.method.replace(/[^A-Za-z]/g, '').slice(0, 2).toUpperCase());
    if (st.length) parts.push(lengthNum(st.length));
    var wg = weightGrams(st.weight); if (wg) parts.push(wg);
    if (isDual(st)) parts.push('S1', sideCodeSeg(st.sides[0]), 'S2', sideCodeSeg(st.sides[1]));
    else { var seg = sideCodeSeg(st.sides[0]); if (seg) parts.push(seg); }
    return parts.filter(Boolean).join('-');
  }
  function sideSummary(s) {
    if (!s.blend && !s.colours.length) return '';
    var bits = [];
    if (s.colours.length) bits.push(s.colours.map(function (c) { return c.label; }).join(', '));
    if (s.blend) bits.push(s.blend);
    if (s.rootShade && s.rootLength && s.rootLength !== 'None') bits.push(s.rootShade.label + ' ' + s.rootLength + ' root');
    return bits.join(' · ');
  }

  /* ===================== validation ===================== */
  function coloursValid(side) { var b = blendByName(side.blend); if (!b) return false; var n = side.colours.length; return n >= b.min && n <= b.max; }
  function ratioValid(side) {
    var b = blendByName(side.blend);
    if (!b || b.single) return true;            // single: no ratio
    if (side.ratioMode !== 'custom') return true; // even split
    var labels = (side.colours || []).map(function (c) { return c.label; });
    if (!labels.length) return false;
    var sum = 0;
    for (var i = 0; i < labels.length; i++) { var v = side.ratios ? side.ratios[labels[i]] : null; if (v == null || isNaN(v) || v <= 0) return false; sum += Number(v); }
    return sum === 100;
  }
  function sideComplete(side) {
    if (!side.rootLength) return false;
    if (side.rootLength !== 'None' && !side.rootShade) return false;
    return coloursValid(side) && ratioValid(side);
  }
  function isComplete(st) {
    if (!(st.family && st.method && st.length && st.weight)) return false;
    return isDual(st) ? (sideComplete(st.sides[0]) && sideComplete(st.sides[1])) : sideComplete(st.sides[0]);
  }

  /* ===================== instance ===================== */
  function emptySide() { return { rootLength: '', rootShade: null, blend: '', colours: [], ratioMode: 'even', ratios: {} }; }

  function initBuilder(rootEl) {
    var dataEl = rootEl.querySelector('[data-ccs-data]');
    if (!dataEl) return;
    var data; try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var products = (data.products || []).filter(Boolean);
    if (!products.length) return;
    var product = products[0];
    // Two products = two finishes (Full Volume / Natural Finish). They share Type +
    // Method and differ in Length, so a Finish step slots in after Method and filters
    // the lengths. `product` is reassigned on finish so every renderer follows it.
    var MULTI = products.length > 1;
    var familyIcons = data.familyIcons || {};

    var state = { quality: MULTI ? '' : (product.quality || ''), finishIndex: null, family: '', method: '', length: '', weight: '', sides: [emptySide(), emptySide()], stepId: 'category' };

    var dom = {
      stage: rootEl.querySelector('[data-ccs-stage]'),
      progress: rootEl.querySelector('[data-ccs-progress]'),
      back: rootEl.querySelector('[data-ccs-back]'),
      next: rootEl.querySelector('[data-ccs-next]'),
      summary: rootEl.querySelector('[data-ccs-summary]'),
      colourCode: rootEl.querySelector('[data-ccs-colourcode]'),
      add: rootEl.querySelector('[data-ccs-add]'),
      msg: rootEl.querySelector('[data-ccs-msg]'),
      preview: rootEl.querySelector('[data-ccs-preview]'),
      toggle: rootEl.querySelector('[data-ccs-toggle]')
    };
    // When off, single-select steps don't auto-advance — the buyer taps Continue.
    var AUTO_ADVANCE = rootEl.dataset.ccsAutoadvance !== 'false';
    // Price is final once weight is picked (colour choices don't change it), so we
    // can surface it inline on the Add-to-cart button from that point.
    var SHOW_PRICE = rootEl.dataset.ccsPrice !== 'false';
    var ADD_LABEL = (dom.add && dom.add.textContent.trim()) || 'Add to cart';
    var SHOP_CURRENCY = rootEl.dataset.ccsShopCurrency || 'GBP';
    var ACTIVE_CURRENCY = rootEl.dataset.ccsCurrency || (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || SHOP_CURRENCY;
    // GBP sessions can trust the baked-in prices; anything else needs market ones.
    var NATIVE_PRICING = ACTIVE_CURRENCY === SHOP_CURRENCY;
    // Which market this session belongs to — keys into variant.marketPrices.
    // (Currency alone can't be the key: UAE sells in GBP off its own price list.)
    var MARKET = rootEl.dataset.ccsMarket || '';
    // Trade-tier fraction (display only — checkout applies the real discount).
    // Mirrors add-to-cart-button.liquid: price minus round(price * fraction).
    var TRADE = parseFloat(rootEl.dataset.ccsTrade) || 0;
    function tradePrice(cents) {
      var d = product.tradeExcluded ? 0 : TRADE;
      return d > 0 ? cents - Math.round(cents * d) : cents;
    }

    /* ---- step list (dynamic) ---- */
    var LABELS = { category: 'Type', method: 'Method', finish: 'Finish', length: 'Length', weight: 'Weight', rootLength: 'Root', rootColour: 'Root shade', blend: 'Blend', colours: 'Colours', ratio: 'Ratio', sides: 'Colours' };
    function stepList() {
      var s = MULTI ? ['category', 'method', 'finish', 'length', 'weight'] : ['category', 'method', 'length', 'weight'];
      if (isDual(state)) { s.push('sides'); return s; }
      s.push('rootLength');
      if (state.sides[0].rootLength && state.sides[0].rootLength !== 'None') s.push('rootColour');
      s.push('blend', 'colours');
      var b0 = blendByName(state.sides[0].blend);
      if (b0 && !b0.single) s.push('ratio');
      return s;
    }
    function reachable(stepId) {
      // a step is reachable if every prior step is valid
      var list = stepList();
      for (var i = 0; i < list.length; i++) { if (list[i] === stepId) return true; if (!stepValid(list[i])) return false; }
      return false;
    }

    /* ---- ui atoms ---- */
    function tile(label, sel, onClick, sub) { var b = el('button', 'ccs__tile' + (sel ? ' is-selected' : ''), '<span class="ccs__tile-t">' + label + '</span>' + (sub ? '<span class="ccs__tile-s">' + sub + '</span>' : '')); b.type = 'button'; b.addEventListener('click', onClick); return b; }
    function swatch(sh, sel, onClick) { var b = el('button', 'ccs__swatch' + (sel ? ' is-selected' : '')); b.type = 'button'; b.title = sh.label; var d = el('span', 'ccs__swatch-dot'); if (sh.image) d.style.backgroundImage = 'url("' + sh.image + '")'; else if (sh.color) d.style.background = sh.color; b.appendChild(d); b.appendChild(el('span', 'ccs__swatch-cap', sh.label)); b.addEventListener('click', onClick); return b; }
    function grid(cls) { return el('div', 'ccs__grid' + (cls ? ' ' + cls : '')); }
    function head(t, hint) { return el('p', 'ccs__step-h', t + (hint ? ' <span class="ccs__hint">' + hint + '</span>' : '')); }

    /* ---- per-step renderers (into stage) ---- */
    function renderCategory(s) {
      s.appendChild(head('Choose a type'));
      var g = grid('ccs__grid--types');
      CONFIG.families.forEach(function (fam) {
        var has = fam.methods.some(function (m) { return methodsFor(product).indexOf(m) !== -1; });
        if (!has) return;
        var icon = familyIcons[fam.name]; // full icon HTML (SVG mask span or FA <i>), or empty
        var b = el('button', 'ccs__tile ccs__tile--type' + (state.family === fam.name ? ' is-selected' : ''), (icon || '') + '<span class="ccs__tile-t">' + fam.name + '</span>');
        b.type = 'button';
        b.addEventListener('click', function () { if (state.family !== fam.name) { state.family = fam.name; state.method = ''; state.length = ''; state.weight = ''; } advance(); });
        g.appendChild(b);
      });
      s.appendChild(g);
    }
    function renderMethod(s) {
      s.appendChild(head('Method'));
      var g = grid();
      var fam = CONFIG.families.filter(function (f) { return f.name === state.family; })[0];
      var methods = (fam ? fam.methods : methodsFor(product)).filter(function (m) { return methodsFor(product).indexOf(m) !== -1; });
      methods.forEach(function (m) { g.appendChild(tile(m, state.method === m, function () { if (state.method !== m) { state.method = m; state.length = ''; state.weight = ''; } advance(); })); });
      s.appendChild(g);
    }
    function renderFinish(s) {
      s.appendChild(head('Finish', 'changes available lengths'));
      var g = grid();
      products.forEach(function (pr, i) {
        g.appendChild(tile(pr.quality || ('Finish ' + (i + 1)), state.finishIndex === i, function () {
          if (state.finishIndex !== i) {
            state.finishIndex = i;
            product = products[i];
            state.quality = product.quality || '';
            state.length = '';
            state.weight = '';
          }
          advance();
        }));
      });
      s.appendChild(g);
    }
    function renderLength(s) {
      s.appendChild(head('Length'));
      var g = grid('ccs__grid--pills');
      lengthsFor(product, state.method).filter(function (l) { return CONFIG.hiddenLengths.indexOf(lengthNum(l)) === -1; }).forEach(function (l) { g.appendChild(tile(l, state.length === l, function () { if (state.length !== l) { state.length = l; state.weight = ''; } advance(); })); });
      s.appendChild(g);
    }
    function renderWeight(s) {
      s.appendChild(head('Weight'));
      var g = grid('ccs__grid--pills');
      weightsFor(product, state.method, state.length).forEach(function (w) { g.appendChild(tile(w, state.weight === w, function () { state.weight = w; advance(); })); });
      s.appendChild(g);
    }
    function renderRootLength(s) {
      var side = state.sides[0];
      s.appendChild(head('Root', 'optional'));
      s.appendChild(el('p', 'ccs__sub', 'Add a darker root, or choose None.'));
      var g = grid('ccs__grid--pills');
      CONFIG.rootLengths.forEach(function (l) { g.appendChild(tile(l, side.rootLength === l, function () { side.rootLength = l; if (l === 'None') side.rootShade = null; render(); })); });
      s.appendChild(g);
    }
    function renderRootColour(s) {
      var side = state.sides[0];
      s.appendChild(head('Root shade'));
      var shades = (product.rootShades && product.rootShades.length) ? product.rootShades : product.shades;
      renderSwatchPicker(s, shades, side, 'single-root');
    }
    function renderBlend(s) {
      var side = state.sides[0];
      s.appendChild(head('Blend style'));
      var g = grid();
      CONFIG.blends.forEach(function (b) { g.appendChild(tile(b.name, side.blend === b.name, function () { side.blend = b.name; if (b.single && side.colours.length > 1) side.colours = side.colours.slice(0, 1); render(); }, b.single ? 'one shade' : 'two or three')); });
      s.appendChild(g);
    }
    function renderColours(s) {
      var side = state.sides[0];
      var b = blendByName(side.blend);
      var max = b ? b.max : CONFIG.maxColours, min = b ? b.min : 1;
      s.appendChild(head('Choose colours', (min === max ? ('pick ' + max) : ('pick ' + min + '–' + max)) + ' · ' + side.colours.length + ' selected'));
      renderColourPicker(s, side, max);
    }
    function renderSides(s) {
      s.appendChild(head('Colours', state.method + ' — two sides'));
      [0, 1].forEach(function (i) {
        var side = state.sides[i];
        var panel = el('div', 'ccs__side');
        panel.appendChild(el('p', 'ccs__side-h', 'Side ' + (i + 1)));
        // root length
        panel.appendChild(el('p', 'ccs__sub', 'Root'));
        var rg = grid('ccs__grid--pills');
        CONFIG.rootLengths.forEach(function (l) { rg.appendChild(tile(l, side.rootLength === l, function () { side.rootLength = l; if (l === 'None') side.rootShade = null; render(); })); });
        panel.appendChild(rg);
        // root shade (only if length)
        if (side.rootLength && side.rootLength !== 'None') {
          panel.appendChild(el('p', 'ccs__sub', 'Root shade'));
          renderSwatchPicker(panel, (product.rootShades && product.rootShades.length) ? product.rootShades : product.shades, side, 'root');
        }
        // blend
        panel.appendChild(el('p', 'ccs__sub', 'Blend'));
        var bg = grid();
        CONFIG.blends.forEach(function (b) { bg.appendChild(tile(b.name, side.blend === b.name, function () { side.blend = b.name; if (b.single && side.colours.length > 1) side.colours = side.colours.slice(0, 1); render(); }, b.single ? 'one' : '2–3')); });
        panel.appendChild(bg);
        // colours
        var bb = blendByName(side.blend);
        panel.appendChild(el('p', 'ccs__sub', 'Colours' + (bb ? ' <span class="ccs__hint">' + (bb.min === bb.max ? 'pick ' + bb.max : 'pick ' + bb.min + '–' + bb.max) + '</span>' : '')));
        renderColourPicker(panel, side, bb ? bb.max : 3);
        if (bb && !bb.single) { panel.appendChild(el('p', 'ccs__sub', 'Ratio')); renderRatio(panel, side); }
        s.appendChild(panel);
      });
    }
    function renderSwatchPicker(container, shades, side, mode) {
      if (!shades || !shades.length) { container.appendChild(el('p', 'ccs__note', 'No shades found (custom.colour).')); return; }
      var g = grid('ccs__grid--swatches');
      shades.forEach(function (sh) { g.appendChild(swatch(sh, side.rootShade && side.rootShade.label === sh.label, function () { side.rootShade = (side.rootShade && side.rootShade.label === sh.label) ? null : sh; render(); })); });
      container.appendChild(g);
    }
    function renderColourPicker(container, side, max) {
      var shades = product.shades || [];
      if (!shades.length) { container.appendChild(el('p', 'ccs__note', 'No shades found (custom.colour).')); return; }
      var g = grid('ccs__grid--swatches');
      shades.forEach(function (sh) {
        var idx = side.colours.map(function (c) { return c.label; }).indexOf(sh.label);
        g.appendChild(swatch(sh, idx !== -1, function () { if (idx !== -1) side.colours.splice(idx, 1); else if (side.colours.length < max) side.colours.push(sh); render(); }));
      });
      container.appendChild(g);
    }
    function renderRatio(container, side) {
      var modes = grid('ccs__grid--pills');
      [['even', 'Even split'], ['custom', 'Custom ratio']].forEach(function (m) {
        modes.appendChild(tile(m[1], (side.ratioMode || 'even') === m[0], function () { side.ratioMode = m[0]; render(); }));
      });
      container.appendChild(modes);
      if ((side.ratioMode || 'even') !== 'custom') { container.appendChild(el('p', 'ccs__note', 'Colours are blended evenly.')); return; }
      var total = el('p', 'ccs__ratio-total');
      function refreshTotal() {
        var sum = side.colours.reduce(function (a, c) { return a + (Number(side.ratios[c.label]) || 0); }, 0);
        total.className = 'ccs__ratio-total' + (sum === 100 ? ' is-ok' : '');
        total.textContent = 'Total: ' + sum + '%' + (sum === 100 ? ' ✓' : ' — must total 100%');
      }
      var list = el('div', 'ccs__ratios');
      side.colours.forEach(function (c) {
        var r = el('div', 'ccs__ratio-row');
        var dot = el('span', 'ccs__swatch-dot ccs__ratio-dot');
        if (c.image) dot.style.backgroundImage = 'url("' + c.image + '")'; else if (c.color) dot.style.background = c.color;
        r.appendChild(dot);
        r.appendChild(el('span', 'ccs__ratio-label', c.label));
        var inp = document.createElement('input');
        inp.type = 'number'; inp.min = '0'; inp.max = '100'; inp.step = '5'; inp.inputMode = 'numeric'; inp.className = 'ccs__ratio-input';
        inp.value = (side.ratios[c.label] != null ? side.ratios[c.label] : '');
        inp.addEventListener('input', function () {
          var v = inp.value === '' ? null : Math.max(0, Math.min(100, parseInt(inp.value, 10) || 0));
          if (v != null) v = Math.round(v / 5) * 5; // snap to 5s — no fine tuning
          if (v == null) delete side.ratios[c.label]; else side.ratios[c.label] = v;
          refreshTotal(); refresh(); // refresh updates preview + nav without rebuilding the inputs
        });
        inp.addEventListener('change', function () {
          inp.value = (side.ratios[c.label] != null ? side.ratios[c.label] : ''); // reflect the snapped value on blur
        });
        r.appendChild(inp); r.appendChild(el('span', 'ccs__ratio-pct', '%'));
        list.appendChild(r);
      });
      container.appendChild(list);
      refreshTotal();
      container.appendChild(total);
    }
    function renderRatioStep(s) { s.appendChild(head('Ratio', 'even, or set percentages')); renderRatio(s, state.sides[0]); }

    var RENDERERS = { category: renderCategory, method: renderMethod, finish: renderFinish, length: renderLength, weight: renderWeight, rootLength: renderRootLength, rootColour: renderRootColour, blend: renderBlend, colours: renderColours, ratio: renderRatioStep, sides: renderSides };

    /* ---- validity per step (enables Continue) ---- */
    function stepValid(id) {
      var s0 = state.sides[0];
      switch (id) {
        case 'category': return !!state.family;
        case 'method': return !!state.method;
        case 'finish': return state.finishIndex != null;
        case 'length': return !!state.length;
        case 'weight': return !!state.weight;
        case 'rootLength': return !!s0.rootLength;
        case 'rootColour': return !!s0.rootShade;
        case 'blend': return !!s0.blend;
        case 'colours': return coloursValid(s0);
        case 'ratio': return ratioValid(s0);
        case 'sides': return sideComplete(state.sides[0]) && sideComplete(state.sides[1]);
      }
      return false;
    }

    /* ---- navigation ---- */
    function goNext() { var list = stepList(), i = list.indexOf(state.stepId); if (i > -1 && i < list.length - 1 && stepValid(state.stepId)) { state.stepId = list[i + 1]; } render(); }
    // Single-select tiles call this: auto-advance if enabled, else just show the pick.
    function advance() { if (AUTO_ADVANCE) goNext(); else render(); }
    function goBack() { var list = stepList(), i = list.indexOf(state.stepId); if (i > 0) state.stepId = list[i - 1]; render(); }
    function goTo(id) { if (reachable(id)) { state.stepId = id; render(); } }

    /* ---- render ---- */
    function renderProgress() {
      var list = stepList();
      var curIdx = list.indexOf(state.stepId);
      dom.progress.innerHTML = '';
      list.forEach(function (id, i) {
        var done = stepValid(id), cur = id === state.stepId;
        // Position-based fill for the mobile track: past + current = filled, future = hollow.
        var cls = 'ccs__crumb' + (cur ? ' is-current' : '') + (done ? ' is-done' : '');
        if (i < curIdx) cls += ' is-past'; else if (i > curIdx) cls += ' is-future';
        var b = el('button', cls, '<span class="ccs__crumb-n">' + (i + 1) + '</span><span class="ccs__crumb-l">' + LABELS[id] + '</span>');
        b.type = 'button';
        b.addEventListener('click', function () { goTo(id); });
        dom.progress.appendChild(b);
      });
      // Keep the active step centred in the mobile horizontal track. Adjust ONLY the
      // track's scrollLeft — never scrollIntoView, which also scrolls the page
      // vertically and would snap the view up on long steps (e.g. the dual sides).
      var curEl = dom.progress.querySelector('.is-current');
      if (curEl && dom.progress.scrollWidth > dom.progress.clientWidth + 1) {
        var tr = dom.progress.getBoundingClientRect(), er = curEl.getBoundingClientRect();
        dom.progress.scrollLeft += (er.left + er.width / 2) - (tr.left + tr.width / 2);
      }
    }
    function renderNav() {
      var list = stepList(), idx = list.indexOf(state.stepId);
      dom.back.disabled = idx <= 0;
      var isLast = idx >= list.length - 1;
      dom.next.style.display = isLast ? 'none' : '';
      dom.next.disabled = !stepValid(state.stepId);
    }
    function renderStage() {
      var list = stepList();
      if (list.indexOf(state.stepId) === -1) state.stepId = list[list.length - 1];
      dom.stage.innerHTML = '';
      (RENDERERS[state.stepId] || function () {})(dom.stage);
    }
    function render() { renderStage(); renderProgress(); renderNav(); updatePreview(); }
    // Lighter update for live inputs (ratios): refresh progress/nav/preview without
    // rebuilding the stage, so number inputs keep focus.
    function refresh() { renderProgress(); renderNav(); updatePreview(); }

    /* ---- preview ---- */
    function row(k, v) { var r = el('div', 'ccs__summary-row'); r.appendChild(el('dt', null, k)); r.appendChild(el('dd', null, v || '—')); return r; }
    function updatePreview() {
      dom.summary.innerHTML = '';
      if (state.quality) dom.summary.appendChild(row('Quality', state.quality));
      dom.summary.appendChild(row('Type', state.family));
      dom.summary.appendChild(row('Method', state.method));
      dom.summary.appendChild(row('Length', state.length));
      dom.summary.appendChild(row('Weight', state.weight));
      if (isDual(state)) { [0, 1].forEach(function (i) { dom.summary.appendChild(row('Side ' + (i + 1), sideSummary(state.sides[i]))); }); }
      else {
        var s0 = state.sides[0];
        dom.summary.appendChild(row('Root', (s0.rootLength && s0.rootLength !== 'None' && s0.rootShade) ? (strip(s0.rootShade.label) + ' · ' + s0.rootLength) : (s0.rootLength === 'None' ? 'None' : '—')));
        dom.summary.appendChild(row('Blend', s0.blend));
        dom.summary.appendChild(row('Colours', s0.colours.length ? s0.colours.map(function (c) { return c.label; }).join(', ') : ''));
      }
      var code = buildColourCode(state);
      dom.colourCode.textContent = buildColourCodeDisplay(state) || '—';

      var variant = (state.method && state.length && state.weight) ? resolveVariant(product, state) : null;
      var ready = isComplete(state) && !!variant && !!code;
      if (dom.add) {
        dom.add.disabled = !ready;
        dom.add.dataset.variantId = variant ? variant.id : '';
        var priceLabel = '';
        if (SHOW_PRICE && variant) {
          var baked = (variant.marketPrices && MARKET && variant.marketPrices[MARKET]) || null;
          if (baked && baked.a != null) {
            var f = formatMoney(tradePrice(baked.a), baked.c);
            if (f) priceLabel = ' · ' + f;
          } else if (NATIVE_PRICING && variant.price != null) {
            var fn = formatMoney(tradePrice(variant.price), SHOP_CURRENCY);
            if (fn) priceLabel = ' · ' + fn;
          }
        }
        dom.add.textContent = ADD_LABEL + priceLabel;
        if (SHOW_PRICE && variant && !priceLabel && !NATIVE_PRICING) {
          // No baked price for this market (stale metafield / new market): ask the
          // storefront probe, which at least covers the market-listed variants.
          var vid = String(variant.id);
          marketPricesFor(product.handle).then(function (data) {
            if (dom.add.dataset.variantId !== vid) return; // selection moved on while fetching
            var entry = data && data.prices ? data.prices[vid] : null;
            if (entry && entry.cents != null) {
              var pf = formatMoney(tradePrice(entry.cents), data.currency);
              if (pf) dom.add.textContent = ADD_LABEL + ' · ' + pf;
            }
          });
        }
      }
      dom.msg.textContent = (isComplete(state) && !variant) ? 'That combination isn’t available — try a different length or weight.' : '';
    }

    /* ---- add to cart ---- */
    function cartProperties(code) {
      // Visible in cart: Colour Code + the colour-relevant rows. Hidden (_-prefixed,
      // still on the order for the supplier pipeline): formula + the values already
      // shown in the variant title (quality/method/length/weight).
      var props = { 'Colour Code': code, '_Formula': buildFormulaCode(state), '_Quality': state.quality, '_Method': CONFIG.methodLabels[state.method] || state.method, '_Length': state.length, '_Weight': state.weight };
      if (isDual(state)) { props['Side 1'] = sideSummary(state.sides[0]); props['Side 2'] = sideSummary(state.sides[1]); }
      else { var s0 = state.sides[0]; props['Root'] = (s0.rootShade && s0.rootLength !== 'None') ? (s0.rootShade.label + ' (' + s0.rootLength + ')') : 'None'; props['Blend'] = s0.blend; props['Colours'] = s0.colours.map(function (c) { return c.label; }).join(', '); }
      return props;
    }
    if (dom.add) dom.add.addEventListener('click', function () {
      var id = dom.add.dataset.variantId, code = buildColourCode(state);
      if (!id || !code) return;
      dom.add.disabled = true; dom.msg.textContent = 'Adding…';
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: Number(id), quantity: 1, properties: cartProperties(code) }] }) })
        .then(function (r) { if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || e.message || 'Could not add to cart'); }); return r.json(); })
        .then(function () { document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true })); window.location.href = '/cart'; })
        .catch(function (err) { dom.msg.textContent = err.message || 'Something went wrong.'; dom.add.disabled = false; });
    });
    // nav buttons
    if (dom.back) dom.back.addEventListener('click', goBack);
    if (dom.next) dom.next.addEventListener('click', goNext);
    if (dom.toggle) dom.toggle.addEventListener('click', function () { dom.preview.classList.toggle('is-open'); });

    render();
  }

  /* ===================== modal (block trigger) ===================== */
  var modalsBound = false;
  function bindModals() {
    if (modalsBound) return; modalsBound = true;
    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-ccs-open]');
      if (opener) { var id = opener.getAttribute('data-ccs-open'); var dlg = id ? document.getElementById(id) : document.querySelector('dialog[data-ccs-modal]'); if (dlg) { dlg.showModal ? dlg.showModal() : dlg.setAttribute('open', ''); } return; }
      var closer = e.target.closest('[data-ccs-close]');
      if (closer) { var d = closer.closest('dialog'); if (d) { d.close ? d.close() : d.removeAttribute('open'); } return; }
      if (e.target.matches && e.target.matches('dialog[data-ccs-modal]')) e.target.close && e.target.close();
    });
  }

  function boot() { bindModals(); document.querySelectorAll('[data-ccs]').forEach(initBuilder); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
